var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialGmapC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6971_5622)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.06573,
    cy: 5.09375,
    rx: 1.34463,
    ry: 1.40625,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65287 8.66889C4.91864 9.01654 5.18911 9.45216 5.33088 9.71653C5.50373 10.0595 5.57457 10.2911 5.70316 10.7037C5.7785 10.9307 5.84933 11.0002 5.99959 11.0002C6.16314 11.0002 6.23889 10.8843 6.29654 10.7037C6.41613 10.3143 6.50925 10.0178 6.65543 9.73503C6.94348 9.19282 7.30686 8.71079 7.66135 8.24737C7.75887 8.11759 8.37923 7.35292 8.65839 6.74582C8.65839 6.74582 8.99959 6.08303 8.99959 5.15629C8.99959 4.28964 8.66227 3.68713 8.66227 3.68713L7.68742 3.96059L7.09363 5.59192L6.94736 5.81438L6.9167 5.85608L6.87683 5.90707L6.81039 5.99045L6.71287 6.09244L6.18553 6.54143L4.86998 7.33924L4.65287 8.66889Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29244 6.63443C3.61596 7.40413 4.23193 8.07569 4.65286 8.66889L6.88183 5.90675C6.88183 5.90675 6.56741 6.33778 6 6.33778C5.36624 6.33778 4.85229 5.80947 4.85229 5.14218C4.85229 4.68336 5.11377 4.36821 5.11377 4.36821L3.60308 4.78994L3.29244 6.63443Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90841 2.14378C7.64847 2.39404 8.28212 2.91776 8.66319 3.69162L6.88184 5.91145C6.88184 5.91145 7.14331 5.5917 7.14331 5.13748C7.14331 4.45619 6.59379 3.94177 6 3.94177C5.43719 3.94177 5.11377 4.36821 5.11377 4.36821V2.96864L6.90841 2.14378Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7002 3.12151C4.14331 2.57 4.91874 2 5.99111 2C6.50966 2 6.90402 2.14368 6.90402 2.14368L5.11377 4.36821H3.84626L3.7002 3.12151Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29245 6.63443C3.29245 6.63443 3 6.02734 3 5.15138C3 4.32182 3.31023 3.59884 3.70459 3.12622L5.11816 4.37281L3.29245 6.63443Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6971_5622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 9,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGmapC);
export default __webpack_public_path__ + "static/media/social_gmap_c.30d0037e1e0c69233169fcae4419b8ff.svg";
export { ForwardRef as ReactComponent };